import { Link } from 'react-router-dom';
import { RetroTvError } from '../components/ui/RetroTvError';
import { useSeo } from '../lib/useSeo';

export default function NotFoundPage() {
  useSeo({
    title: '404 - nie znaleziono - DAIEN',
    description: 'Ta strona nie istnieje.',
    path: '/404',
    noindex: true,
  });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-bg text-text-primary gap-8">
      <div style={{ transform: 'scale(0.85)' }}>
        <RetroTvError errorMessage="NIE ZNALEZIONO" />
      </div>
      <Link
        to="/"
        className="inline-block bg-accent-to text-bg px-8 py-4 rounded-full font-medium hover:bg-accent-from transition-colors"
      >
        Wróć na stronę główną
      </Link>
    </div>
  );
}
